import React, { ButtonHTMLAttributes, ReactNode } from "react";
import useButtonTheme, { ButtonTheme } from "../../hooks/useButtonTheme";

import Spinner from "../Spinner";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  theme?: ButtonTheme;
  isLoading?: boolean;
}

const Button = ({
  className,
  children,
  disabled,
  theme,
  isLoading = false,
  ...props
}: ButtonProps) => {
  const { text, bg, border } = useButtonTheme(disabled ? "disabled" : theme);

  return (
    <>
      <button
        type="button"
        className={`${className} ${text} ${bg} ${border} ${
          disabled ? "cursor-not-allowed" : ""
        } inline-block px-6 py-3 text-xs font-medium text-center uppercase transition-all duration-300`}
        style={{
          minWidth: "170px",
        }}
        disabled={disabled}
        {...props}
      >
        {isLoading ? <Spinner /> : children}
      </button>
    </>
  );
};

export default Button;
